import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import c3 from 'c3';
import { OEEAndChangeOver } from '../../models/factory-summary';
import { DataAnalyticsHelperService } from '../../services/data-analytics-helper.service';
import { DataAnalyticsService } from '../../services/data-analytics.service';
import { ChangeOverPopupComponent } from './change-over-popup/change-over-popup.component';
import { OeeAndChangeOverPopupComponent } from './oee-and-change-over-popup/oee-over-popup.component';
const monthnames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

@Component({
  selector: 'app-oee-and-change-over',
  templateUrl: './oee-and-change-over.component.html',
  styleUrls: ['./oee-and-change-over.component.scss']
})
export class OeeAndChangeOverComponent implements OnInit {

  @ViewChild('lineGraphDiv') lineGraphDiv: ElementRef;
  @ViewChild('barGraphDiv') barGraphDiv: ElementRef;

  @Input() graphType: string; // oee, changeOver
  @Input() currrentFilter: string;
  @Input() factorySummary: any;
  @Input() oeeAndChangeOverData: OEEAndChangeOver[];
  data: any = {
    oeeData: [],
    formatChangeOverData: [],
    productChangeOverData: [],
    costPercentageData: [],
    xAxisLabels: []
  };

  xAxisData;
  costPercentData;
  oeeData;
  formatCO;
  productCO;
  lineId: string;
  emitDataList: any;
  currentEndWeek: any;
  public oneDate: any;
  public monthName: any;
  public divisionNumber = 1;
  public signType = '';

  constructor(
    private route: ActivatedRoute,
    private requester: DataAnalyticsService,
    private helper: DataAnalyticsHelperService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    setTimeout(() => {
      this.getChartData();
    }, 0);
  }

  getLocalStorageData(key: string) {
    return JSON.parse(sessionStorage.getItem(key));
  }
  getChartData() {
    const daDate = this.getLocalStorageData('selectedDATimeFilter');

    const selectedHourDetail = {};
    this.currentEndWeek = '';
    this.emitDataList = {
      appliedFilterType: daDate ? daDate.appliedFilterType : '',
      dateObj: this.factorySummary ? new Date(this.factorySummary.fromDate) : '',
      selectedHr: selectedHourDetail,
      endWeekFromSelectedDate: this.currentEndWeek,
      startQuarterMonth: null
    };
    this.oneDate = this.emitDataList.dateObj;
    this.monthName = this.oneDate.toLocaleString('en-us', { month: 'short' });

    if (this.oeeAndChangeOverData) {
      this.xAxisData = this.oeeAndChangeOverData.map(axisData => axisData.month);
      this.costPercentData = this.oeeAndChangeOverData.map(costPerData => costPerData.costPercentage);
      this.oeeData = this.oeeAndChangeOverData.map(oeeDat => oeeDat.oee);
      this.formatCO = this.oeeAndChangeOverData.map(format => format.formatChangeOver);
      this.productCO = this.oeeAndChangeOverData.map(product => product.productChangeOver);
    }

    this.xAxisData = ['x'].concat(this.xAxisData);
    this.costPercentData = ['cost'].concat(this.costPercentData);
    this.oeeData = ['oee'].concat(this.oeeData);
    this.formatCO = ['FormatChangeOver'].concat(this.formatCO);
    this.productCO = ['ProductChangeOver'].concat(this.productCO);
    const newOEEArr = [];
    this.oeeData.forEach(oee => {
      if (oee === 0) {
        newOEEArr.push(null);
      } else {
        newOEEArr.push(oee);
      }
    });
    this.oeeData = newOEEArr;
    // this.oeeData = this.oeeData.filter(oee => oee === 0 ? null : oee);
    if (this.graphType === 'oee') {
      this.generateOEEGraph();
    } else {
      this.generateChangeOverGraph();
    }
  }

  generateOEEGraph() {
    c3.generate({
      bindto: this.lineGraphDiv ? this.lineGraphDiv.nativeElement : null,
      data: {
        x: 'x',
        columns: [
          this.xAxisData,
          this.oeeData,
          this.costPercentData,
        ],
        colors: {
          oee: '#D26999',
          cost: '#72A8D5'
        },
        names: {
          oee: 'OEE %',
          cost: 'Cost %'
        }
      },
      line: {
        connectNull: true
      },
      point: {
        show: false
      },
      axis: {
        x: {
          label: {
            text: 'Month',
            position: 'outer-center'
          },
          show: true
        },
        y: {
          label: {
            text: 'Percentage',
            position: 'outer-middle'
          },
          show: true,
          tick: {
            format: ((y) => y + '%'),
            outer: true,
          }
        },
        y2: {
          show: true,
          // max: 100,
          // min: 0,
          // padding: { top: 0, bottom: 0 },
          tick: {
            format: ((y) => y + '%'),
            values: [],
            outer: true,
          }
        }
      },
      tooltip: {
        format: {
          title: (x: number) => (this.emitDataList &&
            (this.emitDataList.appliedFilterType === 'quarter' || this.emitDataList.appliedFilterType === 'year' ||
              this.emitDataList.appliedFilterType === 'month') ? monthnames[x - 1] : (x + + ' ' + this.monthName + ' ')),
          value: (x: number) => x.toFixed(2) + '%'
        }
      },
    });
  }

  generateChangeOverGraph() {
    const thisObj = this;
    c3.generate({
      bindto: this.barGraphDiv ? this.barGraphDiv.nativeElement : null,
      padding: {
        top: 0,
        bottom: 0
      },
      data: {
        x: 'x',
        columns: [
          this.xAxisData,
          this.formatCO,
          this.productCO,
          this.costPercentData,
        ], //
        axes: { //
          FormatChangeOver: 'y', //
          ProductChangeOver: 'y', //
          cost: 'y2'
        }, //
        types: { //
          FormatChangeOver: 'bar', //
          ProductChangeOver: 'bar', //
          cost: 'line' //
        }, //
        colors: { //
          FormatChangeOver: '#32B6E0',
          ProductChangeOver: '#8F82C7', //
          cost: '#82C7C2' //
        }, //
        names: { //
          FormatChangeOver: 'FormatChangeOver', //
          ProductChangeOver: 'ProductChangeOver', //
          cost: 'Cost %' //
        } //
      },
      point: { //
        show: false //
      }, //
      tooltip: { //
        show: true, //
        format: { //
          title: (x: number) => (this.emitDataList &&
            (this.emitDataList.appliedFilterType === 'quarter' || this.emitDataList.appliedFilterType === 'year' ||
              this.emitDataList.appliedFilterType === 'month') ? monthnames[x - 1] : (x + ' ' + this.monthName + ' ')),
          value: (x: number) => (x / thisObj.divisionNumber).toFixed(2) + thisObj.signType
        }
      },
      bar: {
        width: 5
      },
      axis: {
        y: {
          label: {
            text: 'Changeover',
            position: 'outer-middle'
          },
          tick: {
            format: ((x) => x / thisObj.divisionNumber + thisObj.signType)
          }
        },
        y2: {
          label: {
            text: 'Cost %',
            position: 'outer-middle'
          },
          show: true,
          tick: {

            format: (d: any) => d + '%'
          }
        },
        x: {
          label: {
            text: 'Month',
            position: 'outer-center'
          },
          // type: 'category',
          // // tick: {
          // //   rotate: -20,
          // //   multiline: false
          // // },
          // categories: this.data.xAxisLabels

        }

      }
    });
  }


  showPopupOEE() {
    this.dialog.open(OeeAndChangeOverPopupComponent, {
      width: '840px',
      height: '500px',
      data: {
        xAxisLabels: this.xAxisData,
        oeeData: this.oeeData,
        costPercentageData: this.costPercentData,
        monthName: this.monthName,
        divisionNumber: this.divisionNumber,
        signType: this.signType
      }
    });
  }

  showPopupChangeOver() {
    this.dialog.open(ChangeOverPopupComponent, {
      width: '840px',
      height: '500px',
      data: {
        xAxisLabels: this.xAxisData,
        formatChangeOverData: this.formatCO,
        productChangeOverData: this.productCO,
        costPercentageData: this.costPercentData,
        monthName: this.monthName,
        divisionNumber: this.divisionNumber,
        signType: this.signType
      }
    });
  }

}
